import React, {useEffect, useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {error, FORM, info, infoMsg, REQUIRED, saveMsg, success, updateMsg} from "../../../components/i18n/i18n";
import {showToastCustom} from "../../../components/toast/customToast";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {roleProvider} from "../../../providers/roleProvider";
import {roleAccessFirebaseService} from "../../../jwt/_services/security/roleAccesFirebaseService";
import Select from "react-select";
import {showLoader} from "../../../components/loader/loader";
import {useForm} from "react-hook-form";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

export default function FirebaseRoleAccessForm(props) {

    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [roleOptions, setRoleOptions] = useState([]);
    const [role, setRole] = useState(editMode ? props.item?.idRole : null);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    useEffect(() => {
        setLoading(true);
        roleProvider.getOptions()
            .then(result => {
                if (result) {
                    setRoleOptions(result);
                    if (props.item?.idRole) {
                        roleProvider.getItem(props.item?.idRole)
                            .then(data => {
                                setRole(data);
                            });
                    }
                }
                setLoading(false);
            })
            .catch(_ => {
                setLoading(false);
            })
    }, []);


    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            role: savedData?.role
        }
    });

    const changeSelect = (value) => {
        setRole(value);
    }

    const onSubmit = (data, _) => {
        if (role == null) {
            return showToastCustom(error, REQUIRED);
        }
        setLoading(true);
        const dataRequest = {
            role: {id: role.id}
        };
        if (!editMode) {
            //Save
            return roleAccessFirebaseService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, saveMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;
            delete savedData.id;
            if (JSON.stringify(savedData) === JSON.stringify(dataRequest)) {
                return showToastCustom(info, infoMsg);
            }

            return roleAccessFirebaseService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, updateMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true)
    }

    const resetForm = () => {
        setSavedData(null);
        setRole(null)
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
    }

    return (
        <Card>
            {loading && showLoader()}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="id">Id</Label>
                                <Input type="id" name="id" id="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="role">Rol</Label>
                                <Select name="role"
                                        value={role}
                                        options={roleOptions}
                                        placeholder="Selecciona una rol"
                                        isDisabled={disableInputs}
                                        isSearchable={true}
                                        isClearable={true}
                                        innerRef={register}
                                        onChange={changeSelect}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => {
                                        resetForm()
                                    }}/>
                                    <ButtonEdit onClick={() => {
                                        beginEdit()
                                    }}/>
                                    <ButtonCancel onClick={props.toggleParent}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit disabled={loading}/>
                                    <ButtonCancel onClick={props.toggleParent}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}